import { ArrowRightIcon, CheckIcon } from '@heroicons/react/20/solid'
import laurelLeft from '@/assets/images/chatbot-laurel-left.svg'
import laurelRight from '@/assets/images/chatbot-laurel-right.svg'

const DEFAULT_FEATURES = [
  { label: 'AI Chatbot', muted: false },
  { label: '10 Websites', muted: false },
  { label: 'Unlimited visits', muted: true },
]

function CrownMark() {
  return (
    <svg
      aria-hidden="true"
      className="size-[18px] shrink-0 text-[#09090B]"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M3.375 12.938h11.25m-10.5-7.875 3.375 4.5L9 4.688l1.5 4.875 3.375-4.5.75 7.875H3.375l.75-7.875Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function RatingStars() {
  return (
    <span
      aria-label="4.8 out of 5 stars"
      className="flex items-center gap-[2px] py-1.5 text-base leading-none text-[#15803D]"
    >
      <span aria-hidden="true">&#9733;</span>
      <span aria-hidden="true">&#9733;</span>
      <span aria-hidden="true">&#9733;</span>
      <span aria-hidden="true">&#9733;</span>
      <span aria-hidden="true">&#9734;</span>
    </span>
  )
}

export default function GrowthPlanPromoWideHorizontal({
  title = 'Get AI chat bot for all your websites',
  reviewTitle = 'Trusted review',
  reviewRating = 'Rated 4.8/5.0 on Trustpilot & G2',
  reviewCaption = 'More than 500k makers trust CodeDesign.ai',
  sitesBuilt = '4M+',
  sitesBuiltLabel = 'sites',
  sitesBuiltCaption = 'have already been built',
  badge = 'BEST VALUE',
  plan = 'GROWTH . YEARLY',
  price = '$20',
  period = '/mo.',
  billedText = '$240 billed yearly',
  savings = 'SAVE 20%',
  features = DEFAULT_FEATURES,
  cta = 'Continue checkout',
  securityText = 'For your security, all orders are processed via Stripe',
  leftPanelWidthClass = 'xl:w-[536px]',
  onCheckout,
}) {
  return (
    <section
      className="w-full min-w-0 overflow-hidden rounded-2xl border border-[#E4E4E7]/80 bg-white px-px shadow-[0px_20px_60px_-15px_rgba(0,0,0,0.15),0px_8px_24px_-8px_rgba(0,0,0,0.1)]"
      style={{ maxWidth: 'min(940px, calc(100vw - 32px))' }}
    >
      <div className="flex min-w-0 flex-col gap-5 p-5 xl:min-h-[277px] xl:flex-row xl:items-stretch xl:gap-3.5">
        <div className={`flex min-w-0 flex-1 flex-col justify-between gap-8 px-2 py-2 ${leftPanelWidthClass} xl:flex-none`}>
          <h2 className="max-w-[380px] text-[30px] font-semibold leading-9 tracking-[-0.75px] text-[#18181B]">
            {title}
          </h2>

          <div className="flex min-w-0 flex-col items-start gap-6 sm:flex-row sm:items-center sm:gap-8">
            <div className="min-w-0 shrink-0">
              <div className="flex items-start gap-3 whitespace-nowrap">
                <p className="text-lg font-semibold leading-7 text-black">{reviewTitle}</p>
                <RatingStars />
              </div>
              <p className="text-sm font-semibold leading-5 text-[#09090B]">{reviewRating}</p>
              <p className="mt-0.5 text-[10px] leading-3 text-[#71717A]">{reviewCaption}</p>
            </div>

            <div className="flex w-fit shrink-0 items-start justify-start gap-4">
              <img src={laurelLeft} alt="" className="h-[49px] w-[41px] shrink-0" />
              <div className="flex shrink-0 flex-col items-center justify-center text-center">
                <div className="flex items-center justify-center gap-[5px] text-[#09090B]">
                  <p className="text-xl font-medium leading-none tracking-[-0.4px]">{sitesBuilt}</p>
                  <p className="text-sm font-medium leading-none tracking-[0.28px]">{sitesBuiltLabel}</p>
                </div>
                <p className="mt-1 text-xs font-medium leading-[14px] text-[#71717A]/75">
                  {sitesBuiltCaption.split(' ').slice(0, 2).join(' ')}
                  <br />
                  {sitesBuiltCaption.split(' ').slice(2).join(' ')}
                </p>
              </div>
              <img src={laurelRight} alt="" className="h-[49px] w-[41px] shrink-0" />
            </div>
          </div>
        </div>

        <div
          className="flex w-full min-w-0 flex-1 flex-col items-center justify-center gap-[18px] overflow-hidden rounded-2xl border border-[#F59E0B] p-4"
          style={{
            backgroundImage:
              'linear-gradient(155.25deg, rgba(255,176,32,0.2) 22.04%, rgba(255,176,32,0.05) 38.98%, rgba(0,0,0,0) 100%)',
          }}
        >
          <div className="flex w-full flex-col items-start gap-4 sm:flex-row sm:gap-6">
            <div className="flex shrink-0 flex-col items-start justify-center gap-3">
              <div className="flex h-8 w-[117px] items-center justify-center">
                <div className="-rotate-2 rounded-full border border-[#B87700] bg-[#FFB020] shadow-[-1px_1px_2px_rgba(0,0,0,0.25),inset_0px_1.5px_0px_rgba(186,111,48,0.5)]">
                  <div className="flex items-center justify-center gap-1 py-[5px] pl-[7px] pr-[13px]">
                    <CrownMark />
                    <span className="whitespace-nowrap text-xs font-semibold leading-4 text-[#09090B]">
                      {badge}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-0.5">
                <p className="whitespace-nowrap text-base font-semibold leading-6 text-[#71717A]">{plan}</p>
                <p className="whitespace-nowrap text-[30px] font-semibold leading-9 tracking-[-0.75px] text-[#09090B]">
                  {price}
                  <span className="text-sm leading-5 text-[#71717A]">{period}</span>
                </p>
                <p className="whitespace-nowrap text-xs leading-4 text-[#71717A]">{billedText}</p>
              </div>
            </div>

            <div className="flex min-w-0 flex-1 flex-col items-start justify-between gap-3 self-stretch drop-shadow-[0px_8px_5px_rgba(0,0,0,0.1),0px_20px_12.5px_rgba(0,0,0,0.1)] sm:items-end sm:gap-0">
              <p className="whitespace-nowrap text-left text-xs font-semibold leading-4 text-[#22C55E] sm:text-center">
                {savings}
              </p>
              <div className="flex flex-col items-start gap-2">
                {features.map((feature) => (
                  <div key={feature.label} className="flex h-5 items-center gap-1.5">
                    <CheckIcon className="size-[18px] shrink-0 text-[#22C55E]" />
                    <p
                      className={`whitespace-nowrap text-sm leading-5 ${
                        feature.muted ? 'text-[#71717A]' : 'text-[#09090B]'
                      }`}
                    >
                      {feature.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex w-full flex-col items-start gap-2">
            <button
              type="button"
              onClick={onCheckout}
              className="flex w-full cursor-pointer items-center justify-center gap-2 rounded-[14px] bg-[#18181B] py-2.5 text-center text-sm font-medium leading-5 tracking-[-0.1504px] text-white transition-colors hover:bg-[#27272A] focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
            >
              {cta}
              <ArrowRightIcon className="size-4 shrink-0" />
            </button>
            <p className="w-full text-center text-[10px] leading-[15px] tracking-[0.1172px] text-[#9F9FA9] sm:whitespace-nowrap">
              {securityText}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
